import classNames from 'classnames'
import * as React from 'react'

import EntityLink from '../../../../../../containers/EntityLink'
import EntityPath from '../../../../../../containers/EntityPath'
import {getBuildType} from '../../../../../../selectors'
import type {BuildId, BuildTypeId} from '../../../../../../types'
import RowGroup from '../../../../../common/Grid/RowGroup'
import MiddleEllipsis from '../../../../../common/MiddleEllipsis/MiddleEllipsis'
import OverviewStatusIcon from '../../../../../common/ProjectOrBuildTypeIcon/OverviewStatusIcon.container'
import {EntityIconType} from '../../../../../common/ProjectOrBuildTypeIcon/ProjectOrBuildTypeIcon.types'

import styles from './ChangeBuildType.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  buildIds: readonly BuildId[]
  buildTypeId: BuildTypeId
  isDeployment?: boolean
  inHierarchy?: boolean
  level?: number
}

function ChangeBuildType({buildIds, buildTypeId, isDeployment, inHierarchy}: Props) {
  const name = useAppSelector(state => getBuildType(state, buildTypeId)?.name)
  return (
    <RowGroup className={classNames(styles.pathRowGroup, {[styles.inHierarchy]: inHierarchy})}>
      <div className={styles.path}>
        {inHierarchy ? (
          <EntityLink className={styles.entityPath} buildTypeId={buildTypeId}>
            {WrapText => (
              <>
                <OverviewStatusIcon
                  type={EntityIconType.BUILD_TYPE}
                  id={buildTypeId}
                  showPausedInStatus
                  ignoreStatus
                />
                <WrapText>
                  <MiddleEllipsis className={styles.name}>{name}</MiddleEllipsis>
                </WrapText>
              </>
            )}
          </EntityLink>
        ) : (
          <EntityPath
            className={styles.entityPath}
            buildTypeId={buildTypeId}
            withLeafIcon
            withLeafStatusIcon={false}
            showPausedInStatus
          />
        )}
        {buildIds.length === 0 && (
          <div className={styles.notTriggered}>
            {isDeployment ? 'Not deployed' : 'Not triggered'}
          </div>
        )}
      </div>
    </RowGroup>
  )
}

export default ChangeBuildType
